import { render, staticRenderFns } from "./NewPdf.vue?vue&type=template&id=2fd1da42&scoped=true&"
import script from "./NewPdf.vue?vue&type=script&lang=js&"
export * from "./NewPdf.vue?vue&type=script&lang=js&"
import style0 from "./NewPdf.vue?vue&type=style&index=0&id=2fd1da42&prod&scoped=true&lang=css&"
import style1 from "./NewPdf.vue?vue&type=style&index=1&id=2fd1da42&prod&lang=scss&"
import style2 from "./NewPdf.vue?vue&type=style&index=2&id=2fd1da42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd1da42",
  null
  
)

export default component.exports